// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const farigiraf: PokeData = {
  "id": 981,
  "name": "farigiraf",
  "height": 32,
  "weight": 1600,
  "base_experience": 260,
  "types": [
    PokeType.NORMAL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "agility",
    "baton-pass",
    "crunch",
    "astonish",
    "assurance",
    "power-swap",
    "guard-swap",
    "nasty-plot",
    "double-hit",
    "twin-beam"
  ],
  "moves": [
    "tackle",
    "growl",
    "psychic",
    "crunch",
    "prismatic-cage",
    "leer",
    "quick-attack",
    "scratch",
    "zen-headbutt",
    "psy-pulse",
    "purification",
    "scary-face",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 101,
    "item": null,
    "species": [
      {
        "name": "girafarig",
        "order": 234,
        "types": [
          PokeType.NORMAL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "farigiraf",
        "order": 928,
        "types": [
          PokeType.NORMAL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 203,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "twin-beam"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 91,
    "ability_power": 166
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
